const config = {
  API_URL: process.env.API_URL,
  SUPPORT_EMAIL: 'support@example.com',
  SENTRY_PUBLIC_DSN_TABLE: {
    'kenguru.kulm.io':
      'https://7320c286e872458ab46df6527be97f31@sentry.kulm.io/3',
  },
  SENTRY_PUBLIC_DSN_FALLBACK: process.env.SENTRY_PUBLIC_DSN,
};

export default config;
